import { DialogComponent, DialogOpenEvent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

class CartDrawerComponent extends DialogComponent {

  #summaryThreshold = 0.5;

  connectedCallback() {
    super.connectedCallback();

    // ✅ event ของ theme เดิม
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);

    this.addEventListener(DialogOpenEvent.eventName, this.#updateStickyState);

    // ❌ ไม่ต้องใช้ cart:updated แล้ว (เอาออกให้หมด)
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    this.removeEventListener(DialogOpenEvent.eventName, this.#updateStickyState);
  }

  #handleCartAdd = () => {
    this.showDialog();
  };

  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }

  #updateStickyState() {
    const { dialog } = this.refs;
    if (!dialog) return;

    const content = dialog.querySelector('.cart-drawer__content');
    const summary = dialog.querySelector('.cart-drawer__summary');

    if (!content || !summary) {
      dialog.setAttribute('cart-summary-sticky', 'false');
      return;
    }

    const drawerHeight = dialog.getBoundingClientRect().height;
    const summaryHeight = summary.getBoundingClientRect().height;

    const ratio = summaryHeight / drawerHeight;

    dialog.setAttribute(
      'cart-summary-sticky',
      ratio > this.#summaryThreshold ? 'false' : 'true'
    );
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}